import { Divider, Spin } from 'antd'
import { differenceInMinutes } from 'date-fns'
import moment from 'moment'
import * as R from 'ramda'
import React from 'react'

import { START_TIME_FORMAT } from '../../constants/flights'
import { withFlightsData, WithFlightsDataInnerProps } from '../../helpers/firestore'
import { sortedFlightsInRound } from '../../helpers/flights'

import { Tournament } from '../../schemas/Tournament'

import './LiveFlights.css'
import ViewFlightCard from './ViewFlightCard'

type LiveFlightsProps = WithFlightsDataInnerProps & {
  round: number
}

type LiveFlightsState = {
  datetime: Date
}

class LiveFlights extends React.Component<LiveFlightsProps, LiveFlightsState> {
  timer: NodeJS.Timer | undefined
  state = {
    datetime: new Date(),
  }

  componentDidMount() {
    this.timer = setInterval(() => this.tick(), 1000)
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer)
  }

  tick() {
    this.setState({
      datetime: new Date(),
    })
  }

  render() {
    const {
      flightsDataLoaded,
      tournament = {} as Tournament,
      flights = [],
      flightsPlayers = {},
      round,
    } = this.props
    const { datetime } = this.state

    const [pastFlights, futureFlights] = R.partition(
      (flight) => moment(flight.startTime, START_TIME_FORMAT).toDate() < datetime,
      sortedFlightsInRound(round)(flights),
    )
    const displayedPastFlights = R.takeLast(1, pastFlights)

    const cards = (
      <React.Fragment>
        {displayedPastFlights.length > 0 && <h3>Starting</h3>}
        {displayedPastFlights.map((flight) => (
          <ViewFlightCard
            key={flight.id}
            flight={flight}
            flightPlayers={flightsPlayers[flight.id] || []}
            flightSize={tournament.flightSize}
          />
        ))}
        {displayedPastFlights.length > 0 && futureFlights.length > 0 && <Divider />}
        {futureFlights.length > 0 && (
          <React.Fragment>
            <h3>Preparing</h3>
          </React.Fragment>
        )}
        {futureFlights.map((flight) => (
          <ViewFlightCard
            key={flight.id}
            flight={flight}
            flightPlayers={flightsPlayers[flight.id] || []}
            flightSize={tournament.flightSize}
            startsInMinutes={differenceInMinutes(
              moment(flight.startTime, START_TIME_FORMAT).toDate(),
              datetime,
            )}
          />
        ))}
      </React.Fragment>
    )

    const roundIdent = tournament.finalRound && round > tournament.rounds ? 'Final' : `${round}.`

    const content = (
      <div className="LiveFlights">
        <h2>{`Tournament Flights for ${roundIdent} round`}</h2>
        <Divider />
        {cards}
      </div>
    )

    return flightsDataLoaded ? content : <Spin>{content}</Spin>
  }
}

export default withFlightsData(LiveFlights)



// WEBPACK FOOTER //
// ./src/components/flights/LiveFlights.tsx